import React from 'react';
import { X, Save, Trash2, LogOut } from 'lucide-react';
import './CleanupModal.css';

export const CleanupModal = ({ isOpen, onClose, onConfirm, onSaveAndExit, isSaved }) => {
    if (!isOpen) return null;

    return (
        <div className="cleanup-modal-overlay">
            <div className="cleanup-modal">
                <div className="cleanup-header">
                    <h3>{isSaved ? 'Clear Workspace' : 'Unsaved Progress'}</h3>
                    <button className="icon-btn" onClick={onClose}><X size={20} /></button>
                </div>

                <div className="cleanup-body">
                    {isSaved ? (
                        <p>
                            Your project is saved and safe. <br /><br />
                            Are you ready to clear the workspace and start a new project?
                        </p>
                    ) : (
                        <p>
                            You have <strong>unsaved changes</strong>. <br /><br />
                            If you clear the workspace now, this project will be <strong>permanently deleted</strong>.
                        </p>
                    )}
                </div>

                <div className="cleanup-footer">
                    <button className="btn-secondary" onClick={onClose}>
                        Cancel
                    </button>

                    {!isSaved && (
                        <button className="btn-primary" onClick={onSaveAndExit}>
                            <Save size={16} /> Save & Exit
                        </button>
                    )}

                    <button
                        className={isSaved ? "btn-primary" : "btn-danger"}
                        onClick={onConfirm}
                    >
                        {isSaved ? (
                            <>
                                <LogOut size={16} /> Clear Workspace
                            </>
                        ) : (
                            <>
                                <Trash2 size={16} /> Delete Everything
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};
